import Vue from "vue";
import VAnimateCss from "v-animate-css";

Vue.use(VAnimateCss);
